import { ActionType, Actions } from './actions';
import { invoicesAdapter, invoicesInitialState, PostState } from './state';

export function reducer(
  state = invoicesInitialState,
  action: ActionType
): PostState {
  switch (action.type) {
    case Actions.LOAD:
    case Actions.LOAD_SINGLE: {
      return Object.assign({}, state, {
        isLoading: true,
        isLoaded: false,
        hasError: false,
        error: null
      });
    }

    case Actions.LOAD_SUCCESS: {
      return {
        ...invoicesAdapter.addMany(action.payload, state),
        isLoading: false,
        error: null
      };
    }

    case Actions.ERROR: {
      return Object.assign({}, state, {
        error: action.payload.message
      });
    }

    default: {
      return state;
    }
  }
}
